import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './index.css';
import Header from './components/common/Header';
import Hero from './components/hero/Hero';
import Overview from './components/overview/Overview';
import HowItWorks from './components/how-it-works/HowItWorks';
import CoreFeatures from './components/features/CoreFeatures';
import BuiltForYou from './components/built-for-you/BuiltForYou';
import DashboardPreviews from './components/dashboard/DashboardPreviews';
import Security from './components/security/Security';
import Roadmap from './components/roadmap/Roadmap';
import Integrations from './components/integrations/Integrations';
import Footer from './components/common/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import JoinWaitList from './components/Waitlist/JoinWaitlist';
import SmartRecommendationEngine from './components/common/CTASection';
import ComingSoon from './components/Coming Soon/ComingSoon';
import ErrorBoundary from './components/common/ErrorBoundary';

function App() {
  return (
    <>
      <ScrollToTop />
      <div className="App">
        <Header />
        <ErrorBoundary>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Hero />
                  <Overview />
                  <HowItWorks />
                  <CoreFeatures />
                  <BuiltForYou />
                  <DashboardPreviews />
                  <Integrations />
                  <SmartRecommendationEngine />
                  <Security />
                  <Roadmap />
                  <Footer />
                </>
              }
            />
            <Route path="/waitlist" element={<JoinWaitList />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route
              path="*"
              element={
                <div className="text-white text-center p-8">
                  404 Not Found
                </div>
              }
            />
          </Routes>
        </ErrorBoundary>
      </div>
    </>
  );
}

export default App;